import { Palette } from '@mui/material'

export const footerStyles = (palette: Palette) => ({
	display: 'flex',
	justifyContent: 'center',
	marginTop: 'auto',
	gap: '32px',
	fontSize: '14px',
	height: '80px',
	minHeight: '80px',
	backgroundColor: palette.sidebar.gray,
	color: palette.text.darkBlue,
})

export const appNameStyles = {
	fontSize: '20px',
	fontFamily: '"Eczar", serif',
	margin: '0 10px',
}
